const initFormset = (
  containerSel: string,
  addBtnSel: string,
  formClass: string,
  removeBtnClass: string,
  hasData: (form: HTMLElement) => boolean
): void => {
  const container = document.querySelector<HTMLElement>(containerSel);
  const addBtn = document.querySelector<HTMLButtonElement>(addBtnSel);
  if (!container || !addBtn) return;

  container.querySelectorAll<HTMLElement>(`.${formClass}`).forEach((form) => {
    const deleteInput = form.querySelector<HTMLInputElement>(
      "input[type=checkbox]"
    );
    if (deleteInput?.checked) return;
    if (hasData(form)) form.classList.remove("tw-hidden");
  });

  addBtn.addEventListener("click", () => {
    const next = Array.from(
      container.querySelectorAll<HTMLElement>(`.${formClass}.tw-hidden`)
    ).find((el) => {
      const del = el.querySelector<HTMLInputElement>("input[type=checkbox]");
      return !del || !del.checked;
    });
    if (next) next.classList.remove("tw-hidden");
  });

  container.addEventListener("click", (e) => {
    const btn = (e.target as Element).closest(`.${removeBtnClass}`);
    if (!btn) return;
    const form = btn.closest<HTMLElement>(`.${formClass}`);
    if (!form) return;
    const deleteInput = form.querySelector<HTMLInputElement>(
      "input[type=checkbox]"
    );
    if (deleteInput) deleteInput.checked = true;
    form.classList.add("tw-hidden");
  });
};

export const initLanguageFormset = (): void => {
  initFormset(
    "#js-language-formset-container",
    "#js-add-language",
    "js-language-form",
    "js-remove-language",
    (form) => Boolean(form.querySelector<HTMLSelectElement>("select")?.value)
  );
};

export const initFeeFormset = (): void => {
  initFormset(
    "#js-fee-formset-container",
    "#js-add-fee",
    "js-fee-form",
    "js-remove-fee",
    (form) =>
      Boolean(form.querySelector<HTMLInputElement>("input[type=text]")?.value)
  );
};
